import AuthorizationFetcher from 'src/js/authorization/authorization_fetcher';
import {constants, utils} from 'src/js/common';
import {FetcherUtils} from 'src/js/common/utils/fetcher_utils';

const logger = utils.LogUtils.getLogger('UploadFetcher', constants.LIBRARY_NAME);

const UploadFetcher = {
  upload(requestUrl, params) {
    if (!requestUrl) {
      logger.error(`Missing request endpoint, requestUrl: ${requestUrl}`);
    }
    return AuthorizationFetcher.interceptedFetch(requestUrl, {
      method: 'post',
      body: FetcherUtils.prepareFormData(params.data),
    })
      .then(FetcherUtils.processEmptyContentResponse)
      .catch((response) => {
        FetcherUtils.errorHandler(response);
      });
  },
};

export default UploadFetcher;
